import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import { useFreezeScroll, useSmartPositioning } from '../../utils';
import './menuButton.scss';

const MenuButton = ({ trigger, items, onOpenChange, scrollContainerId, preferred = null, status = '' }) => {
   const [open, setOpen] = useState(false);

   const triggerRef = useRef(null);
   const menuRef = useRef(null);

   const { pickerStyles, positionName } = useSmartPositioning({
      open,
      triggerRef,
      containerRef: menuRef,
      preferred,
   });

   useFreezeScroll(scrollContainerId, open);

   const toggleMenu = e => {
      e.stopPropagation();
      setOpen(prev => {
         const next = !prev;
         onOpenChange?.(next);
         return next;
      });
   };

   const closeMenu = () => {
      setOpen(false);
      onOpenChange?.(false);
   };

   const handleMenuItemClick = action => {
      action?.();
      closeMenu();
   };

   return (
      <>
         <div className={`dynamic-menu-wrapper ${open ? 'active' : ''}`}>
            <button ref={triggerRef} onClick={toggleMenu} className="moreoption">
               {(status === 'channel_conversation') &&
                  <div class=" message-dropdown-menu">
                     <span class="message-dropdown">
                        <span class="actionDrop"></span>
                        <i>
                           {trigger}
                        </i>
                     </span>
                  </div>
                 

               }
               {
                  (status !== 'channel_conversation') && trigger
               }
            </button>
         </div>

         {open &&
            createPortal(
               <OutsideClickHandler
                  onOutsideClick={e => {
                     if (menuRef.current?.contains(e.target) || triggerRef.current?.contains(e.target)) return;
                     closeMenu();
                  }}>
                  <div ref={menuRef} className={`dynamic-menu pos-${positionName || 'auto'}`} style={pickerStyles}>
                     {items.map(item => {
                        const key = item.id || item.value || item.label; // use a stable unique field

                        // If item is a valid React element
                        if (React.isValidElement(item)) {
                           return React.cloneElement(item, { key, onClick: closeMenu });
                        }

                        // If item is a component function
                        if (typeof item === 'function') {
                           const ItemComp = item;
                           return <ItemComp key={key} onClick={closeMenu} />;
                        }

                        // Otherwise, assume it's an object with label/icon/formatter
                        return (
                           <button
                              key={key}
                              className={`menu_option ${item?.className || ''}`}
                              onClick={e => {
                                 e.stopPropagation();
                                 handleMenuItemClick(item.formatter);
                              }}>
                              {item.icon} {item.label}
                           </button>
                        );
                     })}
                  </div>
               </OutsideClickHandler>,
               document.body,
            )}
      </>
   );
};

MenuButton.propTypes = {
   trigger: PropTypes.node.isRequired,
   items: PropTypes.arrayOf(
      PropTypes.shape({
         icon: PropTypes.node,
         label: PropTypes.string,
         formatter: PropTypes.func,
      }),
   ).isRequired,
   onOpenChange: PropTypes.func,
   scrollContainerId: PropTypes.string,
   preferred: PropTypes.oneOf(['left', 'right', null]),
};

export default MenuButton;
